export {
  default
} from './route.config';
const _import =  require('../_import_' + process.env.NODE_ENV)

// 占位Layout
export const Layout = _import('Admin/layout/Layout');

// 应用APP
export const SecretaryApp = _import('Admin/App');

//结算工具
export const AdminBatchListMoney = _import('Admin/semesterList/index');
export const AdminCollegeListMoney = _import('Admin/semesterList/collegeList');//学期列表
export const AdminTeachingMaterialList = _import('Admin/semesterList/textBookSchedule');//教材计划表
export const AdminTeachingMaterialManagement = _import('Admin/semesterList/teachingMaterialManagement');//教材管理
export const AdminTeachingCourseManagement = _import('Admin/semesterList/teachingCourseManagement');//课程管理
export const AdminTeachingCourseMaterials = _import('Admin/semesterList/teachingCourseMaterials');//课程使用教材
export const AdminStudentListMoney = _import('Admin/semesterList/studentInformationSheet');//学生信息表
export const AdminSettlementListMoney = _import('Admin/semesterList/settlementMoney');//结算详情页
export const AdminSettlementStudentListMoney = _import('Admin/semesterList/settlementStudentMoney');//学生结算详情页
export const AdminBookCollectionList= _import('Admin/semesterList/bookCollection');//领书申请
export const AdminClassManagement= _import('Admin/semesterList/classManagement');//班级管理
export const AdminTextbookExport= _import('Admin/semesterList/textbookExport');//教材导出

export const AdminTeacherTextBookSchedule = _import('Admin/semesterList/teacherTextBookSchedule');//教师教材计划表
export const AdminTeacherTextBookPrint = _import('Admin/semesterList/printTeacherBook');//教师教材计划表
export const AdminTeacherInformationSheet = _import('Admin/semesterList/teacherInformationSheet');//教师信息表

export const AdminInventoryManagement = _import('Admin/semesterList/inventoryManagement');//库存管理

export const AdminSupplierManagementList = _import('Admin/semesterList/supplierManagement');//供应商管理
export const AdminMessageImport = _import('Admin/semesterList/messageImport');//信息录入
export const AdminSendingBooksManagement = _import('Admin/semesterList/sendingBooksManagement');//发书管理
export const AdminStudentTextbook = _import('Admin/semesterList/studentTextbook');//学生用书
export const AdminSettlementManagement = _import('Admin/semesterList/settlementManagement');//结算管理
export const AdminSettlementDetails = _import('Admin/semesterList/settlementDetails');//结算详情
export const AdminEscrowFee = _import('Admin/semesterList/escrowFee');//代管费管理
export const AdminTeachingMaterialStatistics = _import('Admin/semesterList/teachingMaterialStatistics');//教材统计
export const AdminDataStatistics = _import('Admin/semesterList/dataStatistics');//数据统计
export const AdminStudentEscrowFee = _import('Admin/semesterList/studentEscrowFee');//学生代管费
export const AdminDataCenter = _import('Admin/semesterList/dataCenter');//数据中心
export const AdminDataSupply = _import('Admin/semesterList/dataCenter');//补订数据
export const AdminStudentBookAddition = _import('Admin/semesterList/studentBookAddition');//学生补订
export const AdminStudentBooksAddition = _import('Admin/semesterList/studentBooksAddition');//批量补订
// export const AdminEscrowFeeManageMoney= _import('Admin/semesterList/escrowFeeManage');//数据中心
export const AdminStudentMessage= _import('Admin/semesterList/studentMessage');//学生信息

// 临时配置权限所用页面
export const AdminPermissionConfigPage = _import('Admin/permission/page');

// 后台配置
export const AdminSettingsList = _import('Admin/setting/Index');



// WEBPACK FOOTER //
// ./src/views/Admin/index.js